import React, { Component } from "react";
import styled from "styled-components";
import SwitchReact from "react-switch";
import { NanoFlex } from "./NanoFlex";
import Typography from "./Typography";

const StyledSwitch = styled(NanoFlex)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-end;
  min-height: 85px;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 0px;
    letter-spacing: 0.3px;
    color: #252733;
    margin-right: 10px;
  }
`;

class Switch extends Component {
  constructor(props) {
    super(props);
    this.state = { checked: this.props.checked ?? false, text: this.props.text ?? "Switch" };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({ checked });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.checked !== this.state.checked) {
      if (this.props.onChangeSelection) {
        this.props.onChangeSelection(this.state.checked);
      }
    }
  }

  render() {
    return (
      <StyledSwitch>
        <Typography.p>{this.state.text}</Typography.p>
        <SwitchReact
          onChange={this.handleChange}
          checked={this.state.checked}
          offColor="#E9E9EA"
          onColor="#2A6DEC"
          height={31}
          width={51}
          checkedIcon={false}
          uncheckedIcon={false}
        />
      </StyledSwitch>
    );
  }
}

export default Switch;
